import { OrganizerUpsertPayload } from '../interfaces/organizer-upsert-payload';
import { UpsertOrganizerInput } from '../interfaces/upsert-organizer-input';

/**
 * `adminUserId` — владелец организации, которого запишет `upsertTournament`: бэкенд перезаписывает его
 * при каждом сохранении. При создании это создатель, при правке — нынешний владелец (`Organizer.adminUserId`),
 * не тот, кто сохраняет: иначе правка профиля передаёт организацию с кошельком и подпиской (IMGM-1593).
 */
export function mapPayloadToUpsertInput(data: OrganizerUpsertPayload, adminUserId: number | null): UpsertOrganizerInput {
  const { logo, timezone: _timezone, ...rest } = data;
  return {
    ...rest,
    adminUserId: adminUserId ?? undefined,
    sportType: data.sportType.toString().toUpperCase(),
    logo: logo?.[0]?.img instanceof File ? logo[0].img : undefined,
  };
}
